<template>
  <div class="ux-ugc-wrap">
    <div class="data-panel ugc-panel">
      <ue :pd="ues.pd" :content="ues.content" v-if="$service.PROJ_CODE==='l28' || $service.PROJ_CODE==='demo'"></ue>
      <div class="data-panel-header">
        <h2></h2>
        <div class="extra">评分标准：1-非常难操作，2-较难操作，3-中规中矩，4-较易操作，5-非常容易操作<span style="margin:0 0 0 20px;font-weight: bold;">括号内分数为蛋仔相应体验得分</span></div>        
      </div>      
      <div class="data-panel-content">
        <div class="filter-wrap" style="justify-content:flex-end">
          <div class="filter">
            <label class="ux-filter-title">日期</label>
            <a-radio-group v-model="date_range_radio" style="margin-right: 4px;" button-style="solid">
              <a-radio-button v-for="pdate in options.dates" :key="pdate.value" :value="pdate.id">{{pdate.label}}</a-radio-button>
            </a-radio-group>        
            <a-range-picker v-model="date_range_value"  @change="(v) => changeFilterDate(v)" :disabled-date="disabledRangeDate" :allowClear="false"  v-if="$service.PROJ_CODE!='l28'"/>
            <RangePicker v-model="date_range_value" :defaultValue="date_range_value" @change="(v) => changeFilterDate(v)"  v-else style="width:300px; display: inline-block;"/>
          </div>
        </div>
        <a-table :loading="loading" :pagination="pagination" :columns="dataColumns" :data-source="dataSource" ref="ux-ugc-table" bordered size="middle">  
          <div slot="score" slot-scope="text, record, index">
            <span>{{record}}{{ index }}</span>
          </div>      
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { isNil } from 'lodash';
import RangePicker from "@/components/common/search/range_picker.vue";
import ue from "./ue.vue";

const ColumnItems = [
  { title: '各模块设计体验', children: ['基础平台设计', '玩法组件设计', '装饰组件设计', '规则面板设计'], },
  { title: '具体操作体验', children: ['视角操控', '组件移动', '旋转', '缩放', '复制', '多选', '框选', '组件属性', '地图玩法', '运行浏览', '2D模式']}
]
export default {
  name: 'UxUGCPanel',
  props: {
    api: {
      type: String,
    },
    title: {
      type: String,
      default: '问题清单'
    }
  },  
  components: {
    RangePicker,
    ue
  },
  data() {
    return {
      ues: {
        pd: [{name: '曾国芬', email: 'hzzengguofen@corp.netease.com'}],
        content: [{name: '张锦雯', email: 'wf.zhangjinwen@corp.netease.com'}]
      },
      loading: false,
      datas: [],
      pagination: {
        pageSize: 30,
        showSizeChanger: true,
        showQuickJumper: true,
        size: "middle",
      },
      dataColumns: [],
      date_range_value: [],
      date_range_radio: '',
    }
  },
  mounted() {
    this.initColumns();
    this.getData();
  },
  watch: {
    date_range_radio(value) {
      if(value && value!='') {
        const [start_dt, end_dt] = value.split('|');
        this.date_range_value = [moment(start_dt), moment(end_dt)];
      }
      else {
        this.date_range_value = [];
      }
    }
  },
  computed: {
    dataSource() {
      let [start_date, end_date] = this.date_range_value;
      if(start_date==null) {
        start_date = '2000-01-01'
      }
      if(end_date==null) {
        end_date = '2999-12-31'
      }
      const filterData = this.datas.filter(row => {
        const f_daterange = isNil(row.date) ? true : moment(row.date).isBetween(start_date, end_date, 'day', '[]');
        return f_daterange;
      });
      // custom Sort =>
      const sortedData = filterData.sort((prev, next) => {
        const t = 10000 * Math.sign(((next.date || -1) - (prev.date || -1)));
        return t;
      });      
      return sortedData.map(row => ({
        ...row,
        player: `玩家${row.player +1}`, 
        format_date: isNil(row.date) ? '-' : moment(row.date).format('MM/DD'),
      }))
    },
    options() {
      return {
        dates: [
          { id: `${moment().subtract(7, 'days').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近7天' },
          { id: `${moment().subtract(1, 'months').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近一个月' },
          { id: `${moment().subtract(3, 'months').format('YYYY-MM-DD')}|${moment().format('YYYY-MM-DD')}`, label: '近三个月' },
          { id: '', label: '全部' },
        ],
      }
    },
  },
  methods: {
    initColumns() {
      const scoreItems = []
      ColumnItems.forEach(item=>{
        const column = { 
          title: `${item.title}(1~5分)`, 
          dataIndex: item.title, 
          children: item.children.map(i=>({
            title: <th style="font-size:13px">{i}</th>, 
            dataIndex: i, 
            customRender: (text, record)=> this.scoreRender(item.title, i, record), 
            customCell: (record, rowIndex)=> this.customCell(item.title, i, record), 
          }))
        }
        scoreItems.push(column)
      })
      this.dataColumns = [
        { title: '日期', dataIndex: 'format_date', width: 64, sorter: (a, b)=>{ return a.format_date>b.format_date?1:a.format_date<b.format_date?-1:0} },
        { title: '玩家', dataIndex: 'player', width: 64, sorter: (a, b)=>{ return a.player>b.player?1:a.player<b.player?-1:0} },
        { title: '版本', dataIndex: 'version', width: 64, sorter: (a, b)=>{ return a.version>b.version?1:a.version<b.version?-1:0} },
        ...scoreItems, 
        { title: '主测人', dataIndex: 'facilitator', width: 80},  
      ]
    },
    scoreRender(mod, name, record, rowIndex) {
      const d = record.meta && record.meta[mod] && record.meta[mod][name] ? record.meta[mod][name] : {}
      const l28 = d['L28'] || d['l28']
      const dz = d['蛋仔']
      const color = dz!=null? l28 > dz && l28 >= 4 ? '#009734' : l28<=2 || l28 < dz ? '#ff0001' : '#555' : l28<=2?'#ff0001':'#555'
      return l28==null && dz==null?<div>-</div>:<div><span style={{'color':color, fontSize:'16px'}}>{l28}</span> {dz?`(${dz})`:''}</div>
    },
    customCell: (mod, name, record, rowIndex) => {
      const d = record.meta && record.meta[mod] && record.meta[mod][name] ? record.meta[mod][name] : {}
      const l28 = d['L28'] || d['l28']
      const dz = d['蛋仔']
      const color = dz!=null? l28 > dz && l28 >= 4 ? '#a5d8a3' : l28<=2 || l28 < dz ? '#ffaeaf' : '#fff' : l28<=2? '#ffaeaf':'#fff'
      return {
        style: {
          background: color
        }
      };
    },
    getData() {
      this.loading = true;
       this.$service.query_fixed_module(this.api).then(res => {
         this.loading = false;
         if (res.data) {
           this.datas = res.data || [];
         }
       }).catch(() => {
         this.loading = false;
       });
    },
    changeFilterDate(value) {
      console.log(value)
      const [start_date, end_date] = value;
      this.date_range_radio = `${start_date.format('YYYY-MM-DD')}|${end_date.format('YYYY-MM-DD')}`;
    },
    disabledRangeDate(current) {
      return current && current > moment().endOf('day');
    },
  }
}
</script>

<style lang="less" scoped>
.ux-ugc-wrap {
  .ugc-panel {
    padding-bottom: 20px;
    &.data-panel {
      margin-top: 0;
    }
    .ux-filter-title {
      display: inline-block;
      text-align: right;
      width: 64px;
      margin: 0 12px;
      font-weight: bold;
    }
    .data-panel-content {
      padding-top: 12px;
    }
  }
  
  .filter-wrap {
    display: flex;
    flex-wrap: wrap;
    
  }
  .filter {
    padding-bottom: 12px;
  }
}

.ux-exp-tabs {
  padding-top: 20px;
  &.ant-tabs-card {
    .ant-tabs-content {
      margin-top: -16px;
      // .ant-tabs-tabpane {
      //   background: #fff;
      // }
    }
    .ant-tabs-bar {
      border-color: #fff;
      .ant-tabs-tab {
        border-color: transparent;
        background: transparent;
        font-size: 16px;
        font-weight: bold;
      }
      .ant-tabs-tab-active {
        border-color: #fff;
        background: #fff;
      }
    }
  }
}
</style>